import { defineMessages } from 'react-intl'

export default defineMessages({
  'AddRecommendation.headerWarningMessage': {
    id: 'headerWarningMessage',
    defaultMessage:
      'In some cases, Build+Balance recommendations may ' +
      'be more than what you would like to apply or what your equipment will allow you to apply. ' +
      'You can limit the maximum amount applied of any specific nutrient you choose when you create controller files. ' +
      'If you have questions about this, please contact us at ',
  },
  'AddRecommendation.lab': {
    id: 'addRecommendation.lab',
    defaultMessage: 'Lab',
  },
  'AddRecommendation.setupInfo': {
    id: 'addRecommendation.setupInfo',
    defaultMessage: 'Setup Information',
  },
  'AddRecommendation.targetYield': {
    id: 'addRecommendation.targetYield',
    defaultMessage: 'Target Yield',
  },
  'AddRecommendation.Tons': {
    id: 'addRecommendation.Tons',
    defaultMessage: 'tons',
  },
  'AddRecommendation.Lbs': {
    id: 'addRecommendation.Lbs',
    defaultMessage: 'lbs',
  },
  'AddRecommendation.Kgs': {
    id: 'addRecommendation.Kgs',
    defaultMessage: 'kg',
  },
  'AddRecommendation.LbsPerAc': {
    id: 'addRecommendation.LbsPerAc',
    defaultMessage: 'lbs/ac',
  },
  'AddRecommendation.KgPerHa': {
    id: 'addRecommendation.KgPerHa',
    defaultMessage: 'kg/ha',
  },
  'AddRecommendation.Gals': {
    id: 'addRecommendation.Gals',
    defaultMessage: 'gals',
  },
  'AddRecommendation.L': {
    id: 'addRecommendation.L',
    defaultMessage: 'l',
  },
  'AddRecommendation.targetYieldTooltip': {
    id: 'addRecommendation.targetYieldTooltip',
    defaultMessage:
      'A higher target will require more nutrients. ' +
      'Consider creating multiple recs with different goals to compare.',
  },
  'AddRecommendation.crop': {
    id: 'addRecommendation.crop',
    defaultMessage: 'Crop',
  },
  'AddRecommendation.controllerType': {
    id: 'addRecommendation.controllerType',
    defaultMessage: 'Controller Type',
  },
  'AddRecommendation.controllerTypeTooltip': {
    id: 'addRecommendation.controllerTypeTooltip',
    defaultMessage:
      'Select the model, if known, and a controller file will also be created. ' +
      'You can create a new controller file based on this rec at any time.',
  },
  'AddRecommendation.shapeFileOnlyWarning': {
    id: 'addRecommendation.shapeFileOnlyWarning',
    defaultMessage:
      'Shapefile is the only supported file format. Certain monitor types may not be listed. ' +
      'Please consult the Controller Monitor User Manual, as Controller software versions may affect compatibility.',
  },
  'AddRecommendation.recommendationNotAvailable': {
    id: 'addRecommendation.recommendationNotAvailable',
    defaultMessage: 'Recommendations are only available for jobs with status "Results Posted".',
  },
  'AddRecommendation.removalCrop': {
    id: 'removalCrop',
    defaultMessage: 'Removal Crop',
  },
  'AddRecommendation.removalCropTooltip': {
    id: 'removalCropTooltip',
    defaultMessage: 'Compensate for the nutrients used by a crop grown after sampling.',
  },
  'AddRecommendation.cropGrownQuestion': {
    id: 'cropGrownQuestion',
    defaultMessage: 'Was a crop grown (removal crop) without fertilizer after sampling?',
  },
  'AddRecommendation.removalYield': {
    id: 'removalYield',
    defaultMessage: 'Removal Yield',
  },
  'AddRecommendation.removalYieldTooltip': {
    id: 'removalYieldTooltip',
    defaultMessage: 'Used to calculate lost nutrients from Non-fertilized Crop',
  },
  'AddRecommendation.removalCropWarning': {
    id: 'removalCropWarning',
    defaultMessage: 'Modify with caution. Questions? Call ',
  },
  'AddRecommendation.yes': {
    id: 'yes',
    defaultMessage: 'Yes',
  },
  'AddRecommendation.no': {
    id: 'no',
    defaultMessage: 'No',
  },
  'AddRecommendation.buildBalanceInfo': {
    id: 'buildBalanceInfo',
    defaultMessage:
      'is designed to grow your crop like Maintenance recommendations and, ' +
      'additionally, brings your soil into balance by looking at the base saturations of Ca, K, or Mg.',
  },
  'AddRecommendation.maintenanceInfo': {
    id: 'maintenanceInfo',
    defaultMessage:
      'includes the necessary nutrients to achieve the Target Yield of ' +
      'the selected Crop and a small maintenance buffer.',
  },
  'AddRecommendation.recommendationType': {
    id: 'recommendationType',
    defaultMessage: 'Recommendation Type',
  },
  'AddRecommendation.prescriptions': {
    id: 'addRecommendation.prescriptions',
    defaultMessage: 'Prescriptions',
  },
  'AddRecommendation.prescription': {
    id: 'prescription',
    defaultMessage: 'Prescription',
  },
  'AddRecommendation.nitrogenCredits': {
    id: 'addRecommendation.nitrogenCredits',
    defaultMessage: 'Nitrogen Credits',
  },
  'AddRecommendation.previousCrop': {
    id: 'previousCrop',
    defaultMessage: 'Previous Crop',
  },
  'AddRecommendation.nitroCreditsMsg': {
    id: 'nitroCreditsMsg',
    defaultMessage:
      'Do you want to credit the Nitrogen from your N-fixing Previous Crop ' +
      'to your Nitrogen prescriptions? This will credit nitrogen from these previous crops ' +
      'onto your N prescription.',
  },
  'AddRecommendation.optional': {
    id: 'optional',
    defaultMessage: 'Optional',
  },
  'AddRecommendation.costs': {
    id: 'costs',
    defaultMessage: 'Costs',
  },
  'AddRecommendation.appCostPerAc': {
    id: 'appCostPerAc',
    defaultMessage: 'App Cost/Ac',
  },
  'AddRecommendation.appCostPerHa': {
    id: 'appCostPerHa',
    defaultMessage: 'App Cost/Ha',
  },
  'AddRecommendation.costPerTon': {
    id: 'costPerTon',
    defaultMessage: 'Cost/Ton',
  },
  'AddRecommendation.costPerkg': {
    id: 'costPerkg',
    defaultMessage: 'Cost/kg',
  },
  'AddRecommendation.element': {
    id: 'element',
    defaultMessage: 'Element',
  },
  'AddRecommendation.product': {
    id: 'product',
    defaultMessage: 'Product',
  },
  'AddRecommendation.machineSettings': {
    id: 'machineSettings',
    defaultMessage: 'Machine Settings',
  },
  'AddRecommendation.maximumRate': {
    id: 'maximumRate',
    defaultMessage: 'Max Product Rate',
  },
  'AddRecommendation.minRateType': {
    id: 'minRateType',
    defaultMessage: 'Min Rate Type',
  },
  'AddRecommendation.allowZeroRates': {
    id: 'allowZeroRates',
    defaultMessage: 'Allow zero rates (0 lbs/ac or 0 gal/ac)',
  },
  'AddRecommendation.minRate': {
    id: 'minRate',
    defaultMessage: 'Min Product Rate',
  },
  'AddRecommendation.minRateTip1': {
    id: 'minRateTip1',
    defaultMessage: 'Recommended minimum rates (previously defaulted — please set your minimums, if needed)',
  },
  'AddRecommendation.minRateTip1_1': {
    id: 'minRateTip1_1',
    defaultMessage: 'Fertilizer (dry) = Min Machine 40 lbs/acre',
  },
  'AddRecommendation.minRateTip1_2': {
    id: 'minRateTip1_2',
    defaultMessage: 'Fertilizer (liquid) = Min Machine 3.5 gals/acre',
  },
  'AddRecommendation.minRateTip1_3': {
    id: 'minRateTip1_3',
    defaultMessage: 'Lime = Min Machine 500 lbs/acre',
  },
  'AddRecommendation.minRateTip2': {
    id: 'minRateTip2',
    defaultMessage:
      'Micronutrients can be toxic when used incorrectly, ' +
      'so make sure you put the right product in the right place at the right rate. ' +
      'Consult your local agronomist or fertilizer supplier for the best recommendations for your situation.',
  },
  'AddRecommendation.adjustPrescription': {
    id: 'adjustPrescription',
    defaultMessage: 'Adjust Prescription',
  },
  'AddRecommendation.adjustmentType': {
    id: 'adjustmentType',
    defaultMessage: 'Adjustment Type',
  },
  'AddRecommendation.adjustmentValue': {
    id: 'adjustmentValue',
    defaultMessage: 'Adjustment Value',
  },
  'AddRecommendation.adjustmentType_Percent': {
    id: 'percent',
    defaultMessage: 'Percent',
  },
  'AddRecommendation.adjustmentType_Product': {
    id: 'productRate',
    defaultMessage: 'Product Rate',
  },
  'AddRecommendation.adjustmentType_Element': {
    id: 'ElementLbAc',
    defaultMessage: 'Element (lb/Ac)',
  },
  'AddRecommendation.Lb': {
    id: 'Lb',
    defaultMessage: 'Lb',
  },
  'AddRecommendation.Gal': {
    id: 'Gal',
    defaultMessage: 'gal',
  },
  'AddRecommendation.Bushels': {
    id: 'addRecommendation.Bushels',
    defaultMessage: 'bu',
  },
  'AddRecommendation.previous': {
    id: 'previous',
    defaultMessage: 'Previous',
  },
  'AddRecommendation.submit': {
    id: 'submit',
    defaultMessage: 'Submit',
  },
  'AddRecommendation.cancel': {
    id: 'cancel',
    defaultMessage: 'Cancel',
  },
  'AddRecommendation.status': {
    id: 'addRecommendation.status',
    defaultMessage: 'Status',
  },
  'AddRecommendation.addRecommendation': {
    id: 'addRecommendation.addRecommendation',
    defaultMessage: 'Add Recommendation',
  },
  'AddRecommendation.editRecommendation': {
    id: 'editRecommendation',
    defaultMessage: 'Edit Recommendation',
  },
  'AddRecommendation.recommendations': {
    id: 'addRecommendation.recommendations',
    defaultMessage: 'Recommendations',
  },
  'AddRecommendation.generatingRecommendation': {
    id: 'generatingRecommendation',
    defaultMessage: 'Generating Recommendation',
  },
  'AddRecommendation.progressMessage': {
    id: 'progressMessage',
    defaultMessage: 'Your recommendation is currently  being generated.',
  },
  'AddRecommendation.progressGeneralInfo1': {
    id: 'recommendations1',
    defaultMessage:
      'This process may take several minutes to complete. ' +
      'Once it is finished, the recommendation will be loaded automatically.',
  },
  'AddRecommendation.progressGeneralInfo2': {
    id: 'recommendations2',
    defaultMessage:
      'You may leave this page and return to recommendations table ' +
      'to access the generated recommendation at a later time.',
  },
  'AddRecommendation.maxGreaterThanMin': {
    id: 'maxGreaterThanMin',
    defaultMessage: 'Max value should be greater than or equal to min.',
  },
  'AddRecommendation.greaterThanZero': {
    id: 'greaterThanZero',
    defaultMessage: 'This value should be greater than zero.',
  },
  'AddRecommendation.extraPrescriptionsWarning': {
    id: 'extraPrescriptionsWarning',
    defaultMessage:
      'Each additional Prescription/Product added after the first four will greatly increase ' +
      'the processing time to generate your recommendation & controller files',
  },
  'AddRecommendation.overapplicationWarning': {
    id: 'overapplicationWarning',
    defaultMessage: '{otherFertilizer} may overapply for {elementPick}, which has assigned product {fertilizer}.',
  },
  'AddRecommendation.elementSplit': {
    id: 'elementSplit',
    defaultMessage: 'Element Split',
  },
  'AddRecommendation.elementSplitType': {
    id: 'elementSplitType',
    defaultMessage: 'Element split type',
  },
  'AddRecommendation.elementRate': {
    id: 'elementRate',
    defaultMessage: 'Element Rate',
  },
  'AddRecommendation.percent': {
    id: 'percent',
    defaultMessage: 'Percent',
  },
  'AddRecommendation.lbs/ac': {
    id: 'lbs/ac',
    defaultMessage: 'lbs/ac',
  },
  'AddRecommendation.usg/ac': {
    id: 'usg/ac',
    defaultMessage: 'usg/ac',
  },
  totalForPercentSplitShouldEqual100: {
    id: 'totalForPercentSplitShouldEqual100',
    defaultMessage: 'Total for percent split should equal 100% for {element}',
  },
  splitElementsShouldHaveOnlyOneBlankRate: {
    id: 'splitElementsShouldHaveOnlyOneBlankRate',
    defaultMessage: 'There should only be one blank rate for element rate splits for {element}',
  },
  elementSplitValueMustBeLargerThanZero: {
    id: 'elementSplitValueMustBeLargerThanZero',
    defaultMessage: 'Element split values should be greater than zero or left blank for {element}',
  },
  percentSplitValueMustBeLargerThanZero: {
    id: 'percentSplitValueMustBeLargerThanZero',
    defaultMessage: 'Percent split values must be greater than zero for {element}',
  },
  'PrescriptionList.addCustomBlend': {
    id: 'addCustomBlend',
    defaultMessage: 'Add Custom Blend',
  },
  'OverApplyDialog.title': {
    id: 'overApplyDialog.title',
    defaultMessage: 'Warning: Potential overapplication',
  },
  'OverApplyDialog.continue': {
    id: 'overApplyDialog.continue',
    defaultMessage: 'Continue',
  },
  'OverApplyDialog.cancel': {
    id: 'overApplyDialog.cancel',
    defaultMessage: 'Cancel',
  },
})
